// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SavePatientRequestModel {
    static getAttributeTypeMap() {
        return SavePatientRequestModel.attributeTypeMap;
    }
}
SavePatientRequestModel.discriminator = undefined;
SavePatientRequestModel.additionalProperties = false;
SavePatientRequestModel.attributeTypeMap = [
    {
        "name": "patientUpsearchModel",
        "baseName": "patientUpsearchModel",
        "type": "PatientUpsearchModelSecureUpsearchModel"
    },
];
//# sourceMappingURL=savePatientRequestModel.js.map